import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, saveState, deleteState } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { Pagination } from "../Pagination/Pagination";
import { ButtonBack } from "../Button/Back";
import {getMessagemErro} from "../../utils/erro";
import {formataData} from '../../utils/formatadorData';
import api from "../../services/api";
import { baixarArquivo } from "../../utils/downloadUtil";
import SelectSearch from "../UI/SelectSearch/SelectSearch"
import './Whitelist.css';
import { TIPO_AMBIENTE_HOMOLOGACAO, TIPO_AMBIENTE_PRODUCAO } from "../../providers/constTiposAmbiente";

const mapDispatchToProps = { saveState, deleteState, exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
		filters: state.filterStore,
	}
}

export const WhitelistList =

// router
withRouter(
// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(
	class extends Component {
	
		constructor(props){
			super(props);
			this.initialState = {
				criterioPesquisa: {
					ipOrCidr: '',
					orgao: '',
					tipoAmbiente: '',
				},
				orgaos: [],
				tiposAmbiente: [TIPO_AMBIENTE_HOMOLOGACAO, TIPO_AMBIENTE_PRODUCAO],
				resultadoPesquisa: {},
				pesquisaExecutada: false,
				botoesHabilitados : true,
			};

			this.state = this.initialState;
			this.handleInputChange = this.handleInputChange.bind(this);
			this.pesquisar = this.pesquisar.bind(this);
			this.executaPesquisaPaginada = this.executaPesquisaPaginada.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);
			this.mostraRelatorioCSV = this.mostraRelatorioCSV.bind(this);
			this.mostraRelatorioPDF = this.mostraRelatorioPDF.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					
					<div style={{margin: "10px"}}>
						<h1>Listar IPs Liberados</h1>
					</div>
					
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			
			const user = this.props.user;
			if(user.isAdministrador || user.isMantenedor){
				api.get('/api/orgao/perfil-usuario?ativos=true')
					.then(response => { 
						this.setState((prevState) => ({...prevState, orgaos: response.data }) )
					})
					.catch(erro => {
						const msg = getMessagemErro("Não foi possível recuperar os órgãos.", erro);
						console.log(JSON.stringify(msg));
						this.props.exibeMensagemErro(msg.mensagem, msg.erros);
					});
			}

			if (!this.props.location.state?.resetSearch) {
				this.executarPesquisaAnterior();
			}
		}

		renderForm() {
			const user = this.props.user;

			const { criterioPesquisa, resultadoPesquisa, pesquisaExecutada, orgaos, tiposAmbiente } = this.state;
			const { content } = resultadoPesquisa;
			const exibeBotoes = content && content.length > 0;
			const { orgao, tipoAmbiente, ipOrCidr } = criterioPesquisa;

			return(
				<div className="container-fluid">
					<div className="br-form">
						{ (user.isAdministrador || user.isMantenedor) &&
							<div className="row">
								<div className="col-sd">
									<div className="field">
										<div className="input">
											<label>IP ou CIDR:</label>
											<input type="text" name="ipOrCidr" value={ipOrCidr}  onChange={this.handleInputChange} maxLength={43}/>
										</div>
									</div>
								</div>

								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>Órgão:</label>
											<SelectSearch
												id="orgao"
												name="orgao"
												includeAllOption={true}
												options={orgaos.map(orgao => ({ value: orgao.id, label: orgao.nome }))}
												onChange={this.handleInputChange}
												value={orgao}
											/>
										</div>
									</div>
								</div>
							</div>
						}

						<div className="row">
							<div className="col-sm-2">
								<div className="field">
									<div className="input">
										<label>Ambiente:</label>
										<SelectSearch
											id="tipoAmbiente"
											name="tipoAmbiente"
											includeAllOption={true}
											options={tiposAmbiente.map(tipoAmbiente => ({ value: tipoAmbiente.id, label: tipoAmbiente.nome }))}
											onChange={this.handleInputChange}
											value={tipoAmbiente}
										/>
									</div>
								</div>
							</div>
						</div>

						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={() => this.pesquisar()} disabled={!this.state.botoesHabilitados}>Pesquisar</button>
								{exibeBotoes === true &&	<button type="button" className="button is-secondary" onClick={this.mostraRelatorioPDF} disabled={!this.state.botoesHabilitados}>Relatório PDF</button>}
								{exibeBotoes === true &&	<button type="button" className="button is-secondary" onClick={this.mostraRelatorioCSV} disabled={!this.state.botoesHabilitados}>Relatório CSV</button>}
								<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()} disabled={!this.state.botoesHabilitados}>Limpar</button>
								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>
					
						{(content && content.length > 0) &&	
							<div className="br-table">						
								<div className="table">
									<table>
										<thead>
											<tr>
											<th scope="col" style={{width: "50%"}}>Órgão</th>
											<th scope="col">Ambiente</th>
											<th scope="col">CIDR</th>
											<th scope="col" style={{width: "10%"}} className="text-center">Data de Cadastro</th>
											</tr>
										</thead>
										
										<tbody>
											{ content.map((whitelist, index) =>
													<tr key={index} >
														<td>{whitelist.nomeOrgao}</td>
														<td>{whitelist.nomeTipoAmbiente}</td>
														<td>{whitelist.cidr}</td>
														<td className="text-center">{formataData(whitelist.dataCadastro)}</td>
													</tr>
												)}
										</tbody>
									</table>
									<Pagination totalPaginas={resultadoPesquisa.totalPages} paginaAtual={resultadoPesquisa.number} onChangePage={this.executaPesquisaPaginada}/>
								</div>
							</div>
						}

						{(pesquisaExecutada && (! content || content.length === 0)) &&
							<div>
								Nenhum cadastro encontrado com os critérios informados.
							</div>
						}
					</div>
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const criterioPesquisa = this.state.criterioPesquisa;
			criterioPesquisa[nome] = valor;
			this.setState((prevState) => ({ ...prevState, criterioPesquisa }));
		}

		executarPesquisaAnterior() {
			const lastState = this.props.filters[this.props.location.pathname];

			this.setState((prevState) => ({
				...prevState,
				...lastState,
				pesquisaExecutada: false,
				resultadoPesquisa: {}
			}), () => {
				if (lastState) {
					const lastPage = lastState ? lastState?.resultadoPesquisa?.number : 0;
					this.executaPesquisaPaginada(lastPage);
				}
			});	
		}

		pesquisar (e){
			this.props.limpaMensagem();
			this.executaPesquisaPaginada(0);
			if (this.props.location.state?.resetSearch) {
				this.props.history.replace(this.props.location.pathname, {
					...this.props.location.state,
					resetSearch: false,
				  });
			}
		}

		executaPesquisaPaginada (pagina){
			const {criterioPesquisa} = this.state;
			criterioPesquisa['pagina'] = pagina;
			const url = '/api/whitelist/paginado';

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa
			}

			this.props.mostraAguardando();
			api(options)
				.then(response => { 
					this.setState((prevState) => ({
						...prevState,
						resultadoPesquisa: response.data,
						pesquisaExecutada : true,
					}), () => {
						this.props.saveState(this.state, this.props.location.pathname);
					}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar os IPs liberados. " + erro)
					this.props.exibeMensagemErro("Erro durante a execução da pesquisa.")
				})
				.then(() => {
					this.props.escondeAguardando();
				});
		}

		limparPesquisa(){
			this.setState((prevState) => (
				{
					...prevState,
					criterioPesquisa: {
						orgao: '',
						tipoAmbiente: '',
						ipOrCidr: '',
					},
					resultadoPesquisa: {},
					pesquisaExecutada: false,
					botoesHabilitados : true,
				}), () => {
					this.props.deleteState(this.state, this.props.location.pathname);
				}
			)
		}

		mostraRelatorioCSV(e){
			this.mostraRelatorio(e, 'csv');
		}

		mostraRelatorioPDF(e){
			this.mostraRelatorio(e, 'pdf');
		}

		mostraRelatorio(e, tipo){
			const { criterioPesquisa } = this.state;
			const url = `/api/whitelist/${tipo}`;

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa,
				responseType: 'arraybuffer'
			}

			this.props.mostraAguardando();
			this.setState((prevState) => ({ ...prevState, botoesHabilitados : false }));

			api(options)
				.then((response) => {
					baixarArquivo(new Blob([response.data]), `RelatorioIPsLiberados.${tipo}`);
				})				
				.catch(response => {
					const erro = {data: JSON.parse(Buffer.from(response.data).toString('utf8'))};
					const mensagemInicial = 'Não foi possível recuperar o relatório com os IPs liberados';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState((prevState) => ({...prevState, botoesHabilitados : true}));
				});
		}
		
	}

) // redux
); // router